module.exports = __webpack_public_path__ + "static/img-certified-02-471ca543c3b466f7d6aef44c8b2d7743.png";